import { h, render } from 'preact';
import { useEffect, useState, useMemo } from 'preact/hooks';
import ColumnComponent from './column-component';

export default (element, data) => {
  const VScentColumns = ({columns}) => {
    const [activeItem, setActiveItem] = useState(undefined);

    useEffect(() => {
    }, [])

    const columnsList = useMemo(
      () =>
        columns.map((item, index) => (
          <ColumnComponent
            key={index}
            index={index}
            data={item}
            isActive={activeItem === index}
            setActiveItem={setActiveItem}
            activeItem={activeItem}
          />
        )),
      [activeItem],
    );
    return (
      <columns-container
        className="relative overflow-hidden w-screen h-full laptop:h-[800px] flex flex-col laptop:flex-row"
      >
        { columnsList }
      </columns-container>
    );
  };

  const init = () => {
    render(<VScentColumns {...data} />, element);
  };

  init();
};
